import {ScrollArea} from 'alm-react-components';
import {useTranslation} from 'react-i18next';
import {defaultImage} from '../../../lib/utils';
import {constants} from '../../../assets/constants/constants';
import {useLayoutEffect} from 'react';
import PageLoader from '../../common/loader/PageLoader';
const VideoTutorialWeekDetails = ({
  courseList,
  courseUpdate,
  courseId,
  courseType,
  loading,
}: any) => {
  const { t } = useTranslation();
  const handleCourseEnrollment = async (cardSelected: any, id: any) => {
    !cardSelected && courseUpdate(id);
  };
  useLayoutEffect(() => {
    if (courseId) {
      const element = document.getElementById(`box-${courseId}`) as HTMLElement;
      if (element) {
        element.scrollIntoView();
        element.scrollIntoView(false);
        element.scrollIntoView({block: 'end'});
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'end',
          inline: 'nearest',
        });
      }
    }
  }, [courseList]);

  if (loading || !courseList?.length) {
    return <PageLoader />;
  }

  return (
    <>
      {courseId && (
        <div className="" key={courseId}>
          <h4 className="font-light tracking-wider text-base font-barlowLight p-2 pb-3"></h4>
          <ScrollArea className="class-list-item-scroller">
            {courseList &&
              courseList?.map((course: any, index: number) => {
                const cardSelected = courseId == course?.id ? 'card-selected' : null;
                return (
                  <>
                    <div
                      key={index + '_' + course?.id}
                      onClick={() => {
                        handleCourseEnrollment(cardSelected, course?.id);
                      }}
                      id={`box-${course?.id}`}
                      className={`flex my-1 p-2 rounded-xl w-full md:w-[95%] lg:w-full relative dark:text-gray-300 dark:hover:bg-fillMidGrayCard cursor-pointer dark:hover:text-white hover:bg-transparent   ${cardSelected}`}
                    >
                      <div className="flex-none relative rounded-lg border mr-3 bg-fillMidGrayCard hover:opacity-100 hover:bg-black md:w-[80px] md:h-[54px] lg:w-[119px] lg:h-[72px] overflow-hidden">
                        {course?.imageUrl ? (
                          <img
                            src={course?.imageUrl}
                            alt={t('CourseDetails.fallbackText')}
                            className="w-full h-[inherit] object-cover bg-center lg:col-span-full"
                          />
                        ) : courseType == constants.BULLETINS ||
                          courseType == constants.DOCUMENT ||
                          courseType == constants.BOOKS ? (
                          ''
                        ) : (
                          <img
                            src={defaultImage()}
                            alt={t('CourseDetails.fallbackText')}
                            className="w-full h-[inherit] object-cover bg-center lg:col-span-full"
                          />
                        )}
                      </div>
                      <div className="flex flex-col w-full">
                        {/* <p className=" font-opensansMedium text-base">lesson 1</p> */}
                        <p className="font-opensansSemiBold lg:text-base xl:text-lg">
                          {course?.name}
                        </p>
                      </div>
                    </div>
                  </>
                );
              })}
          </ScrollArea>
        </div>
      )}
    </>
  );
};

export default VideoTutorialWeekDetails;
